import { REQUEST_TYPE } from './request';

export enum LEAVE_STATUS {
  ACQUIRED = 'Acquired',
  TAKEN = 'Taken',
  AVAILABLE = 'Available',
}

export enum LEAVE_TYPE {
  SIMPLE = 'SIMPLE',
  EXCEPTIONAL_LEAVE = 'EXCEPTIONAL_LEAVE',
  SICK_LEAVE = 'SICK_LEAVE',
}

export enum LEAVE_ORIGIN_TYPE {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum CUMULATIVE_TYPE {
  N = 'N',
  NMINUS1 = 'NMINUS1',
  NMINUS2 = 'NMINUS2',
}

export const PAID_LEAVE_GAINED_STANDARD = 1.5;
export const PAID_LEAVE_GAINED_STANDARD_RATE = 1 / 16;
export const PAID_LEAVE_TYPE: Map<REQUEST_TYPE, LEAVE_TYPE> = new Map([
  [REQUEST_TYPE.LEAVE, LEAVE_TYPE.SIMPLE],
  [REQUEST_TYPE.EXCEPTIONAL_LEAVE, LEAVE_TYPE.EXCEPTIONAL_LEAVE],
  [REQUEST_TYPE.SICK_LEAVE, LEAVE_TYPE.SICK_LEAVE],
]);
